import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { AircraftSearchCriteria } from '../../../aircraft/components/aircraft-search/aircraft-search-criteria.model';
import { Observable } from 'rxjs';

@Injectable()
export class AircraftSearchBarService extends BaseApiService {

    public search = (aircraftSearchCriteria: AircraftSearchCriteria): Observable<any> => this.post('Aircraft/Aircraft/Search', aircraftSearchCriteria);

    public getAircraftInformation = (aircraftId: number): Observable<any> => this.get(`Aircraft/Aircraft/${aircraftId}`);
}
